import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Grid from '@material-ui/core/Grid';
import {
    lightBlue,
    amber,
    lightGreen,
    red,
    purple,
} from '@material-ui/core/colors';
import {
    Storage,
    SupervisorAccount,
    Timelapse,
    Warning,
    Store,
} from '@material-ui/icons';
import withOrdersRouter from '../withOrdersRouter';
import DashboardCard from "../DashboardCard/DashboardCard";


const style = {
    pendingOrdersCard: {
        padding: 24,
        backgroundColor: lightBlue[500],
        color: '#FFFFFF',
        cursor: 'pointer',
    },
    vendorQueueCard: {
        padding: 24,
        backgroundColor: purple[500],
        color: '#FFFFFF',
        cursor: 'pointer',
    },
    inProgressOrdersCard: {
        padding: 24,
        backgroundColor: amber[500],
        color: '#FFFFFF',
        cursor: 'pointer',
    },
    pendingReviewOrdersCard: {
        padding: 24,
        backgroundColor: lightGreen[500],
        color: '#FFFFFF',
        cursor: 'pointer',
    },
    exceptionOrdersCard: {
        padding: 24,
        backgroundColor: red[500],
        color: '#FFFFFF',
        cursor: 'pointer',
    },
    icon: {
        fontSize: 48,
        fontWeight: 400,
    }
};
export class Dashboard extends Component {
    render() {
        return (
            <div id="dashboard">
                <Grid container spacing={1}>
                    {/*Pending Orders Card*/}
                    <DashboardCard
                        title="Queue"
                        cardStyle={style.pendingOrdersCard}
                        isFetching={this.props.isFetchingCounts}
                        total={this.props.totalOrdersInTheQueue}
                        onClick={this.props.goToPendingOrders}
                        icon={
                            <Storage style={style.icon} />
                        }
                    />

                    {/* Vendor queue card */}
                    <DashboardCard
                        title="Vendor Queue"
                        cardStyle={style.vendorQueueCard}
                        isFetching={this.props.isFetchingCounts}
                        total={this.props.totalOrdersInTheVendorQueue}
                        onClick={this.props.goToPendingVendorOrders}
                        icon={
                            <Store style={style.icon} />
                        }
                    />

                    {/* My Orders In Progress Card*/}
                    <DashboardCard
                        title="My Orders in Progress"
                        cardStyle={style.inProgressOrdersCard}
                        isFetching={this.props.isFetchingCounts}
                        total={this.props.totalMyOrdersInProgress}
                        onClick={this.props.goToMyOrdersInProgress}
                        icon={
                            <Timelapse style={style.icon} />
                        }
                    />

                    {/*Pending Review Orders Card*/}
                    {
                        this.props.isSketchOsAdmin &&
                        <DashboardCard
                            title="Pending Admin Approval"
                            cardStyle={style.pendingReviewOrdersCard}
                            isFetching={this.props.isFetchingCounts}
                            total={this.props.totalOrdersPendingSketchOsAdmin}
                            onClick={this.props.goToOrdersPendingSketchOsAdmin}
                            icon={
                                <SupervisorAccount style={style.icon} />
                            }
                        />
                    }

                    {/*Needs Attention Card*/}
                    {
                        this.props.isSketchOsAdmin &&
                        <DashboardCard
                            title="Needs Attention"
                            cardStyle={style.exceptionOrdersCard}
                            isFetching={this.props.isFetchingCounts}
                            total={this.props.totalExceptionOrders}
                            onClick={this.props.goToOrdersWithException}
                            icon={
                                <Warning style={style.icon} />
                            }
                        />
                    }

                    {/*Billing Failed Orders*/}
                    {
                        this.props.isSketchOsAdmin &&
                        <DashboardCard
                            title="Failed to Bill"
                            cardStyle={style.exceptionOrdersCard}
                            total={this.props.totalBillingFailedOrders}
                            isFetching={this.props.isFetchingCounts}
                            onClick={this.props.goToBillingFailedOrders}
                            icon={
                                <Warning style={style.icon} />
                            }
                        />
                    }

                    {/*Rush Orders Pending / In Progress*/}
                    {
                        <DashboardCard
                            title="Filtered Rush Orders"
                            cardStyle={style.pendingOrdersCard}
                            total={this.props.filteredRushOrders}
                            isFetching={this.props.isFetchingCounts}
                            onClick={this.props.goToRushOrders}
                            icon={
                                <Warning style={style.icon} />
                            }
                        />
                    }
                </Grid>
            </div>
        );
    }
}

Dashboard.propTypes = {
    totalOrdersInTheQueue: PropTypes.number.isRequired,
    isFetchingOrdersInTheQueue: PropTypes.bool.isRequired,
    totalOrdersInTheVendorQueue: PropTypes.number.isRequired,
    isFetchingOrdersInTheVendorQueue: PropTypes.bool.isRequired,
    totalOrdersPendingSketchOsAdmin: PropTypes.number.isRequired,
    isFetchingOrdersPendingSketchOsAdmin: PropTypes.bool.isRequired,
    totalExceptionOrders: PropTypes.number.isRequired,
    isFetchingExceptionOrders: PropTypes.bool.isRequired,
    totalMyOrdersInProgress: PropTypes.number.isRequired,
    isFetchingMyOrdersInProgress: PropTypes.bool.isRequired,
    totalBillingFailedOrders: PropTypes.number.isRequired,
    totalRushOrders: PropTypes.number.isRequired,
    filteredRushOrders: PropTypes.number.isRequired,
    isFetchingBillingFailedOrders: PropTypes.bool.isRequired,
    goToPendingOrders: PropTypes.func.isRequired,
    goToPendingVendorOrders: PropTypes.func.isRequired,
    goToMyOrdersInProgress: PropTypes.func.isRequired,
    goToOrdersPendingSketchOsAdmin: PropTypes.func.isRequired,
    goToOrdersWithException: PropTypes.func.isRequired,
    goToBillingFailedOrders: PropTypes.func.isRequired,
    goToRushOrders: PropTypes.func.isRequired,
    isFetchingCounts: PropTypes.bool.isRequired,
};

export default withOrdersRouter(Dashboard);
